import script from "./HealthInsuranceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthInsuranceForm.vue?vue&type=script&setup=true&lang=js"

import "./HealthInsuranceForm.vue?vue&type=style&index=0&id=e6bfc2ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6bfc2ec"]])

export default __exports__